import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Header from "../components/Header";
import Hero from "../components/Hero";
import SchoolLogos from "../components/SchoolLogos";
import Problem from "../components/Problem";
import Method from "../components/Method";
import Services from "../components/Services";
import Schools from "../components/Schools";
import Proof from "../components/Proof";
import Pricing from "../components/Pricing";
import FAQ from "../components/FAQ";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";

const LandingPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className="min-h-screen bg-[#FDFCF8]">
      <Header />
      
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: isLoaded ? 1 : 0 }}
        transition={{ duration: 0.5 }}
      >
        <Hero />
        <SchoolLogos />
        <Problem />
        <Method />
        <Services />
        <Schools />
        <Proof />
        <Pricing />
        <FAQ />
        <FinalCTA />
      </motion.main>
      
      <Footer />
    </div>
  );
};

export default LandingPage;
